import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content main__content" }
const _hoisted_2 = { class: "main__container" }
const _hoisted_3 = { class: "content__container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "content__date" }, "Today", -1)
const _hoisted_5 = { class: "content__records" }
const _hoisted_6 = { class: "record__info" }
const _hoisted_7 = { class: "record__date" }
const _hoisted_8 = {
  key: 0,
  class: "record__details"
}
const _hoisted_9 = { class: "record__details-text" }
const _hoisted_10 = {
  key: 1,
  class: "record__album"
}
const _hoisted_11 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "record content__record",
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", {
                  class: _normalizeClass(["record__text", item.recordType])
                }, _toDisplayString(item.recordText), 3),
                _createElementVNode("p", _hoisted_7, _toDisplayString(item.recordDate), 1)
              ]),
              (item.recordHasDetails)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(item.recordDetails), 1)
                  ]))
                : _createCommentVNode("", true),
              (item.recordHasImg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (item) => {
                      return (_openBlock(), _createElementBlock("img", {
                        key: item.id,
                        src: require('../assets/'+item.img),
                        onClick: ($event: any) => (_ctx.getItemIndex(item.id)),
                        alt: "record-img",
                        class: "record__album-img"
                      }, null, 8, _hoisted_11))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}